import { emitDocumentPreviewOpenRequested } from '@/features/documentPreview/documentPreviewEvents.js'
import { isRenderable } from '@/features/documentPreview/renderableArtifact.js'
import { buildGeneratedArtifactAssistantMessagePatch } from '@/utils/generatedArtifactAssistantPayload'

/** @param {import('./runResponseComponentDemoStream.js').DemoStreamCtx & { trimmed: string }} ctx */
export function runGeneratedArtifactTurn(ctx) {
  const { tid, pendingId, trimmed, signal, session, setMessagesByThreadId } = ctx

  session.addTimeout(() => {
    if (signal.aborted) {
      session.dispose()
      return
    }
    let artifact = null
    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const idx = list.findIndex((m) => m.id === pendingId)
      if (idx === -1) return inner
      const built = buildGeneratedArtifactAssistantMessagePatch(
        trimmed,
        list[idx].thinkingStartedAt ?? list[idx].createdAt,
      )
      if (!built) return inner
      artifact = built.artifact
      const next = [...list]
      next[idx] = { ...next[idx], ...built.messagePatch }
      return { ...inner, [tid]: next }
    })
    if (isRenderable(artifact)) emitDocumentPreviewOpenRequested(artifact)
    session.dispose()
  }, 500)
}
